import React from 'react';
import { useNavigate } from 'react-router-dom';

const PreviousStoreAdCard = ({ ad }) => {
    console.log("Ad Data:", ad);

      // Formatting helpers
    const formatCurrency = (val) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
    const formatDate = (date) => new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

    const navigate = useNavigate()
    return (
        <div className="store-ad-card"> {/* Main Wrapper */}
            <div className="shop-header">
                  <span className="ad-type-tag">Business</span>
                <div className="shop-info-wrapper">
                    <div className="shop-logo flexed-center">
                        {ad?.store.logo?.url ? (
                            <img
                                src={ad.store.logo.url}
                                alt={`${ad?.store.name || 'Store'} logo`}
                                className='shop-logo-img'
                            />
                        ) : (
                            <div className="shop-logo-img flexed-center">
                                {ad?.store.name?.charAt(0) || "?"}
                            </div>
                        )}
                    </div>

                    <div className="shop-info-details">
                        <h1 className="shop-name">
                            {ad?.store.name || "Unknown Store"}
                        </h1>
                    </div>
                </div>

                <div className="shop-banner flexed-center">
                    {ad?.store.banner?.url ? (
                        <img
                            src={ad.store.banner.url}
                            alt="Store banner"
                            className='shop-image-banner'
                        />
                    ) : (
                        <div className="shop-img-banner flexed-center">
                            <h3 className='shop-img-banner-text'>
                                {ad?.store.name}
                            </h3>
                        </div>
                    )}
                </div>

                <div className="shop-desc">
                    <p className='shop-description'>
                        {ad?.store.description || "No description available"}
                    </p>
                </div>
            </div>

            <div className="store-countries">
                <h3>Countries</h3>
                {ad?.countries && ad.countries.length > 0 ? (
                    ad.countries.map((country, index) => (
                        <p key={`${country}-${index}`}>{country}</p>
                    ))
                ) : (
                    <p>No countries listed</p>
                )}
            </div>
              <section className="ad-metrics-grid">
                <div className="metric-item">
                    <span className="metric-label">Total Budget</span>
                    <span className="metric-value">{formatCurrency(ad.budget)}</span>
                </div>
                <div className="metric-item">
                    <span className="metric-label">Profile Visits</span>
                    <span className="metric-value">{ad.results.visits}</span>
                </div>
            </section>

            <div className="ad-details-list">
                <div className="detail-row">
                    <span className="detail-label">Started:</span>
                    <span className="detail-value">{formatDate(ad.startDate)}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Ends:</span>
                    <span className="detail-value">{formatDate(ad.endDate)}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Payment:</span>
                    <span className="detail-value" style={{ color: ad.payments.status === 'pending' ? '#f59e0b' : '#10b981' }}>
                        {ad.payments.status.toUpperCase()}
                    </span>
                </div>
            </div>

            <footer className="ad-card-footer">
                <button className="btn-view-analytics">
                    Analyze Performance
                </button>
            </footer>
            <button className="promote-again-btn" onClick={() => navigate(`/b/manage/${ad.store.name}/promotions/:${ad._id}`, { state: { ad:ad.store } })}>
                Promote Again
            </button>
        </div>
    );
};

export default PreviousStoreAdCard;